import { designToken, quickProperty } from '../component-tokens';
import { nameWithSize, sizeAttributes } from './utils';
import { tertiaryElement, tertiaryElementHover, tertiaryElementFocus, tertiaryElementActive, buttonBase, } from './common';
const iconButtonAttrs = Object.assign(Object.assign(Object.assign(Object.assign({}, buttonBase), tertiaryElement), sizeAttributes('40px')), { 'align-items': quickProperty('center'), 'justify-content': quickProperty('center'), 'background-color': designToken('interactive-02'), 'border-color': designToken('interactive-02'), font: designToken('button-text-medium'), padding: quickProperty('0') });
export const iconButtonTokens = {
    name: 'icon-button',
    tag: 'chameleon-icon-button',
    reactImports: 'IconButton',
    attributes: iconButtonAttrs,
    children: [
        {
            name: 'icon',
            attributes: Object.assign(Object.assign({}, sizeAttributes('24px')), { color: designToken('icon-01'), 'pointer-events': quickProperty('none') }),
        },
    ],
    sizes: [
        Object.assign(Object.assign({}, nameWithSize('xsmall', '24px')), { children: [
                Object.assign({}, nameWithSize('icon', '16px')),
            ], tag: 'button' }),
        Object.assign(Object.assign({}, nameWithSize('small', '32px')), { children: [
                Object.assign({}, nameWithSize('icon', '16px')),
            ], tag: 'button' }),
        Object.assign(Object.assign({}, nameWithSize('large', '48px')), { children: [
                Object.assign({}, nameWithSize('icon', '22px')),
            ], tag: 'button' }),
    ],
    states: [
        {
            name: 'hover',
            attributes: Object.assign({}, tertiaryElementHover),
        },
        {
            name: 'focus',
            attributes: Object.assign({}, tertiaryElementFocus),
        },
        {
            name: 'active',
            attributes: Object.assign({}, tertiaryElementActive),
        },
    ],
    variants: [
        {
            name: 'achromatic',
            states: [
                // TODO get those validated by UX
                {
                    name: 'hover',
                    attributes: {
                        'background-color': designToken('hover-02'),
                        'border-color': designToken('hover-02'),
                    },
                },
                {
                    name: 'focus',
                    attributes: Object.assign({}, tertiaryElementFocus),
                },
                {
                    name: 'active',
                    attributes: {
                        'background-color': designToken('pressed-02'),
                        'border-color': designToken('pressed-02'),
                        'box-shadow': quickProperty('none'),
                    },
                },
            ],
            children: [
                {
                    name: 'icon',
                    attributes: {
                        color: designToken('text-01'),
                    },
                },
            ],
        },
        {
            name: 'disabled',
            attributes: {
                'background-color': designToken('interactive-02'),
                'border-color': designToken('interactive-02'),
                'box-shadow': quickProperty('none'),
                cursor: quickProperty('default'),
            },
            children: [
                {
                    name: 'icon',
                    attributes: {
                        color: designToken('disabled-04'),
                    },
                },
            ],
        },
    ],
};
